import { DeckGlInstance } from 'types';

import {
    SetMapControlsReturn,
    SetMapReturn,
    SetOutlineIntervalReturn,
    SetPlaybackControlsReturn,
} from '../actions/mapActions';

export interface MapState {
    map: DeckGlInstance | null;
    mapControls: object;
    playbackControls: object;
    outlineInterval: number;
}

const initialState: MapState = {
    map: null,
    mapControls: {},
    playbackControls: {},
    outlineInterval: 60,
};

type MapAction = SetMapReturn | SetMapControlsReturn | SetPlaybackControlsReturn | SetOutlineIntervalReturn;
// Define the reducer
export const mapReducer = (state: MapState = initialState, action: MapAction): MapState => {
    switch (action.type) {
        case 'SET_OUTLINE_INTERVAL':
            // @ts-ignore
            return { ...state, outlineInterval: action.payload };
        case 'SET_MAP':
            // @ts-ignore
            return { ...state, map: { ...state.map, ...action.payload } };

        case 'SET_MAP_CONTROLS':
            // @ts-ignore
            return { ...state, mapControls: { ...state.mapControls, ...action.payload } };
        case 'SET_PLAYBACK_CONTROLS':
            // @ts-ignore
            return { ...state, playbackControls: action.payload };
        default:
            return state;
    }
};
